import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import {
  GetSessionSummaryResponse,
  PaymentAccount,
  PaymentPreviewV1Response,
  PaymentRulesResponseV1,
  TransactionAuthorizationResult,
} from '@arc/unified-payments-frontend/shared-payment';

// BTPAY-7254: dispatched by the Wallet "Back" cold-load landing page (make-payment-international's
// payment-receipt component). Own actions throughout (no shared SessionActions/
// BtPayPaymentInformationActions dispatches) so this cold-load path can't cause side effects
// in the live checkout flow — mirroring POI's payment-receipt component. Registered alongside
// POI's own actions in make-payment-core's pay-on-invoice.reducer.ts, since international
// shares that same core state.
export const PoiIntlPaymentReceiptComponentActions = createActionGroup({
  source: 'POI Intl Payment Receipt Component',
  events: {
    Initialized: props<{ sessionId: string }>(),
    'Load Session Summary Success': props<{
      payload: GetSessionSummaryResponse;
    }>(),
    'Load Session Summary Error': props<{ error: HttpErrorResponse }>(),
    'Selected Payment Account Loaded': props<{
      selectedPaymentAccount: PaymentAccount;
    }>(),
    'Update Transaction Authorization Results': props<{
      transactionAuthorizationResult: TransactionAuthorizationResult[];
      transactionReference: string;
    }>(),
    'Load Payment Preview Success': props<{
      payload: PaymentPreviewV1Response;
    }>(),
    'Load Payment Preview Error': props<{ error: HttpErrorResponse }>(),
    'Load Payment Rules Success': props<{
      payload: PaymentRulesResponseV1;
    }>(),
    'Load Payment Rules Error': props<{ payload: HttpErrorResponse }>(),
  },
});
